import {} from 'utilities/file';

class FiltersInterface {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/filters`;
    this.apiClient = apiClient;

  }

  async createEmptyFilter(collectionId, data = {}) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, { collectionId }, {}, data);

  }

  async getFiltersByCollectionId(collectionId) {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, { collectionId }, {});

  }

  async updateFilterById(collectionId, filterId, data) {

    const path = `${this.basePath}/:filterId`;

    return this.apiClient.put(path, { collectionId, filterId }, {}, data);

  }

  async pushFilterReference(collectionId, filterId, reference) {

    const path = `${this.basePath}/:filterId/add-reference`;

    return this.apiClient.put(path, { collectionId, filterId }, {}, reference);

  }

  async pullFilterReference(collectionId, filterId, reference) {

    const path = `${this.basePath}/:filterId/remove-reference`;

    return this.apiClient.put(path, { collectionId, filterId }, {}, reference);

  }

  async deleteFilter(collectionId, filterId) {

    const path = `${this.basePath}/:filterId`;

    return this.apiClient.delete(path, { collectionId, filterId }, {});

  }

}

export default FiltersInterface;